import './MobileProductCard.scss';

import React, { memo } from 'react';
import { connect } from 'react-redux';
import {
  IProduct,
  IProductMenuDisplay,
} from 'core/redux/features/products/types';
import { AppState } from 'core/redux/reducers';
import { makeSelectProductMenuListPreviewById } from 'core/redux/features/products/reducers/products';
import ProductImage from '../Components/ProductImage';
import { ProductAddress } from '../Components/ProductAddress';
import { CardFooter } from '../Components/CardFooter';
import { OverlayTextDecider } from '../OverlayText';

export const ProductHeader = ({
  product,
  menuPreviews,
}: {
  product: IProduct;
  menuPreviews: IProductMenuDisplay[];
}) => {
  return (
    <header className="card-header map-board__content">
      <div className="grid-list between">
        <div className={`${product?.status === 'in-stock' ? '_7 _item' : ''}`}>
          <p className="title">
            <span className="is-ellapsis">{product.name}</span>
          </p>
          <ProductAddress product={product} />
        </div>
        {product?.status === 'in-stock' ? (
          <div className="_item _3">
            <div className="tag-price">
              <span className="normal">
                {menuPreviews[0]?.price_regular}
                <small>kr</small>
              </span>
              <span className="tag sale is-multiline">
                {menuPreviews[0]?.price_sale}
                <small>KR</small>
              </span>
            </div>
          </div>
        ) : null}
      </div>
    </header>
  );
};

const mapStateToProps = (state: AppState, { product }) => {
  const selectProductMenuListPreviewById =
    makeSelectProductMenuListPreviewById();
  return {
    menuPreviews: selectProductMenuListPreviewById(state, product.id),
  };
};

const mapDispatchToProps = {
  // onToggleMenu: navActions.toggle,
};

interface IProps {
  product: IProduct;
}

type TProps = IProps &
  ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

export function ProductCard({ product, menuPreviews }: TProps) {
  return (
    <div className="card product-card">
      <ProductHeader product={product} menuPreviews={menuPreviews} />
      <div className="card-image">
        <ProductImage isLazy={false} productId={product.id} />
        <OverlayTextDecider productId={product.id} />
      </div>
      <CardFooter deviceType="mobile" product={product} menus={menuPreviews} />
    </div>
  );
}

const configure = connect(mapStateToProps, mapDispatchToProps)(ProductCard);

export default memo(configure);
